<script setup lang="ts">
import { computed, onMounted } from 'vue';
import Icon from '@components/icons/icon.vue';
import Button from '@components/buttons/button.vue';
import {
    DisabledPropsInterface,
    useDisableComposable,
} from '@src/application/composables/disabled-composable.js';

const props = withDefaults(defineProps<DisabledPropsInterface & {
    icon?: string,
    iconConfig?: Array<string>,
    context?: 'default'|'primary'|'danger'|'warning',
    content?: string,
}>(), {
    context: 'default',
});

const { disabled } = useDisableComposable();

onMounted(() => {
    if (props.icon === undefined && props.iconConfig === undefined) {
        console.error('prop icon or icon-config must be set');
    }
});

const iconColor = computed(() => {
    if (disabled.value) {
        return 'inherit';
    }
    if (props.context === 'default' || props.context === 'warning') {
        return 'default';
    }
    return 'white';
});
</script>

<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>

<template>
    <Button :class="$style.icon_button" :context="context" v-bind="$attrs">
        <div v-if="iconConfig !== undefined" :class="$style.icon__wrapper">
            <Icon v-for="iconEntry in iconConfig" :class="$style.icon" :icon="iconEntry" :icon-color="iconColor"/>
        </div>
        <Icon v-if="icon !== undefined" :class="$style.icon" :icon="icon" :icon-color="iconColor"/>
        <p :class="$style.content">
            <slot>
                {{ content }}
            </slot>
        </p>
    </Button>
</template>

<style lang="scss" module>
@use '@text' as *;

.icon_button {
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
        margin-bottom: 1px;
        font-size: 95%;
    }
    .content:empty {
        display: none;
    }
    .content:not(:empty) {
        margin-left: 1em;
    }
    .icon__wrapper .icon + .icon {
        margin-left: .3em;

        @media (min-width: 38em) {
            margin-left: .5em;
        }
    }
}
</style>
